<template>
  <!-- <div class="page-sales">
      <div class="page-header">
        <el-menu
          :default-active.sync="activeIndex"
          class="el-menu-sales"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="/legal/documents">Documentos</el-menu-item>
          <el-menu-item index="/legal/kpi">KPI</el-menu-item>
        </el-menu>
      </div>
  
      <router-view></router-view>
    </div> -->
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "LegalMTR",
  data() {
    return {
      activeIndex: "/legal/documents"
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSelect(key, keyPath) {
      if (key.charAt(0) === "/") {
        this.$router.push(key);
        this.$emit("push-page", { page: key });
      }
    },
    setLink(path) {
      this.activeIndex = path;
    }
  },
  created() {
    if (this.$router.currentRoute.path === "/legalrb") {
      this.handleSelect(this.activeIndex);
    }
    this.setLink(this.$router.currentRoute.path);
    // eslint-disable-next-line
      this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.path);
    });
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
